import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { addAccessedCode } from '../lib/tripHistory';

export default function JoinByLink() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) { navigate('/home'); return; }
    const upper = code.toUpperCase();
    try {
      addAccessedCode(upper);
    } catch {}
    navigate(`/trip/${upper}`, { replace: true });
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-[#F4F6F5] flex items-center justify-center" data-testid="join-by-link">
      <p className="text-[#455561] text-sm">Joining event...</p>
    </div>
  );
}
